import { useLanguage } from "@/context/LanguageContext";
import { QRCodeCanvas } from "qrcode.react";
import { Button } from "@/components/ui/button";
import { Copy, Download, Printer } from "lucide-react";
import { toast } from "sonner";

export function TablesQR() {
  const { t } = useLanguage();

  const copyLink = (n) => {
    navigator.clipboard.writeText(`${window.location.origin}/menu?table=${n}`);
    toast.success(`${t("link_copied")} — ${t("table")} ${n}`);
  };

  return (
    <div data-testid="tables-qr">
      <div className="flex flex-wrap items-center gap-3 mb-4 bg-white border border-[#E8DFD5] rounded-2xl p-4">
        <Printer className="w-5 h-5 text-[#D97706]" />
        <div className="flex-1 min-w-[200px]">
          <p className="text-sm font-semibold text-[#4A2C2A]">{t("print_qr_title")}</p>
          <p className="text-xs text-[#786C66]">{t("print_qr_desc")}</p>
        </div>
        <a href="/qr-tavoli.pdf" download="QR-tavoli-Caffetteria-del-Fortino.pdf" data-testid="download-qr-pdf">
          <Button size="sm" className="rounded-full bg-[#4A2C2A] hover:bg-[#36201F] text-[#FDFBF7] gap-1.5">
            <Download className="w-4 h-4" /> {t("download_pdf")}
          </Button>
        </a>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-testid="tables-qr-grid">
      {Array.from({ length: 12 }, (_, i) => i + 1).map((n) => (
        <div key={n} data-testid={`qr-table-${n}`} className="bg-white border border-[#E8DFD5] rounded-2xl p-4 flex flex-col items-center shadow-[0_8px_30px_rgb(0,0,0,0.06)]">
          <QRCodeCanvas
            value={`${window.location.origin}/menu?table=${n}`}
            size={140}
            bgColor="#FFFFFF"
            fgColor="#4A2C2A"
            level="M"
          />
          <p className="font-heading font-bold text-[#4A2C2A] mt-3">{t("table")} {n}</p>
          <div className="flex gap-1 mt-2">
            <Button
              data-testid={`copy-link-${n}`}
              variant="outline"
              size="sm"
              onClick={() => copyLink(n)}
              className="rounded-full border-[#E8DFD5] text-[#4A2C2A] gap-1 text-xs"
            >
              <Copy className="w-3.5 h-3.5" /> {t("copy_link")}
            </Button>
            <a href={`/qr-tavolo-${n}.png`} download={`QR-tavolo-${n}.png`} data-testid={`download-qr-${n}`}>
              <Button variant="outline" size="sm" className="rounded-full border-[#E8DFD5] text-[#4A2C2A] gap-1 text-xs">
                <Download className="w-3.5 h-3.5" />
              </Button>
            </a>
          </div>
        </div>
      ))}
      </div>
    </div>
  );
}
